import React, { useState } from "react";
import { useSelector } from "react-redux";
import classNames from "classnames";
import { brandingSelector } from "Utils/selectors";
import { Button } from "Components/ReactstrapSlim";
import { ContactUsModal, FormType } from "Components/Modal";
import { EnterpriseDemoRequestMode } from "Services/API/API";

interface HeaderRightProps {
   className?: string;
}
export const HeaderRight: React.FC<HeaderRightProps> = function ({ className }) {

   const branding = useSelector(brandingSelector);

   const [enterpriseRequestModalOpened, setEnterpriseRequestModalOpened] = useState(false);
   const toggleEnterpriseRequestModal = () => {
      setEnterpriseRequestModalOpened((wasOpened) => !wasOpened);
   }

   return branding
      ? null
      : <div className={classNames("header-right", className)}>
         <Button color="transparent" className="header-btn-link" onClick={() => toggleEnterpriseRequestModal()}>
            Get demo
         </Button>
         {enterpriseRequestModalOpened && <ContactUsModal toggle={toggleEnterpriseRequestModal} isOpen={enterpriseRequestModalOpened} formType={FormType.Specific} formName="Get demo" mode={EnterpriseDemoRequestMode.Enterprise} centered />}
      </div>
}